import React from 'react';

export type WalletCoupon = {
    Name?: string
    WebSummary?: string
    Description?: string
    IconUrl?: string
    Code?: string
}

type WalletCouponCardProps = {
    coupon: WalletCoupon
}

export default function WalletCouponCard(props: WalletCouponCardProps) {
    const c = props.coupon;
    return (
        <div className={'bl-wallet-coupon'} style={{display: 'flex', padding: '12px', borderRadius: '12px', border: '1px solid #E5E7EB', marginBottom: '12px'}}>
            {c.IconUrl ? (
                <img src={c.IconUrl} alt={c.Name} style={{width: '72px', height: '72px', borderRadius: '12px', objectFit: 'cover'}} />
            ) : (
                <div style={{width: '72px', height: '72px', borderRadius: '12px', background: 'linear-gradient(180deg, #5AA2FF, #7BB7FF)', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: 700}}>COUPON</div>
            )}
            <div style={{marginLeft: '16px', textAlign: 'left'}}>
                <div style={{fontWeight: 700}}>{c.Name}</div>
                {c.Description && <div style={{fontSize: '0.9rem'}}>{c.Description}</div>}
            </div>
        </div>
    );
}



